module.exports = __webpack_public_path__ + "img/image.03f39927.svg";